import React from 'react';
import { useLocation } from 'react-router-dom';
import { Col, Row } from 'antd';
import ComponentDevices from './ComponentDevices';

export default function SessionsExpired() {
  const location = useLocation();
  const { retData } = location.state || {};
  return (
    <Row>
      <Col span={5} />
      <Col span={19}>
        <ComponentDevices retData={retData} limitBanner />
      </Col>
    </Row>
  );
}
